module.exports = "Change the time period shown<br> by dragging the sliders ";


//////////////////
// WEBPACK FOOTER
// ./src/js/tour/tourYearsFilter.html
// module id = 35
// module chunks = 0